import Library from '../views/Library.vue';

export const routes = [
  {
    path: '/library',
    name: 'Library',
    component: Library,
  },
];
